'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { Container } from '@/app/components/layouts/container';
import { PaginationNumber } from '@/app/components/navigation/pagination';
import { FeatureNewsCard } from '@/app/lcv/components/sections/news-activities/feature-card';
import { NewsCard } from '@/app/lcv/components/sections/news-activities/news-card';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { NEWS_PER_PAGE } from '@/services/news-activities';
import type { LcvNewsDetail } from '@/types/tis-cms/types';
export interface NewsActivitiesContentProps {
  pinned?: LcvNewsDetail;
  entries: LcvNewsDetail[];
  total: number;
  currentPage: number;
  pageBaseUrl: string;
}
export const NewsActivitiesListing = t0 => {
  const $ = _c(19);
  const {
    pinned,
    entries,
    total,
    currentPage,
    pageBaseUrl
  } = t0;
  const router = useRouter();
  const totalPages = Math.ceil(total / NEWS_PER_PAGE);
  let t1;
  if ($[0] !== pageBaseUrl || $[1] !== router) {
    t1 = page => {
      const url = page <= 1 ? pageBaseUrl : `${pageBaseUrl}/page/${page}`;
      router.push(url);
      window.scrollTo(0, 0);
    };
    $[0] = pageBaseUrl;
    $[1] = router;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handlePageChange = t1;
  let t2;
  if ($[3] !== pinned) {
    t2 = !!pinned && <Container size="desktop-only" className="lg:px-13"><FeatureNewsCard {...pinned} className="mb-8 sm:mb-10" displayMode="list" preload={true} testId="news-activities-highlight" /></Container>;
    $[3] = pinned;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = createDataAttributes({
      test: "section-news-activities-listing"
    });
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== entries) {
    t4 = entries.length === 0 ? <div className="flex flex-col items-center justify-center py-24 text-center text-gray-500 md:py-28" {...createDataAttributes({
      test: "empty-state"
    })}><p>ขออภัย ยังไม่มีข่าวสารและกิจกรรม</p></div> : <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:gap-8" {...createDataAttributes({
      test: "news-grid"
    })}>{entries.map(_temp)}</div>;
    $[6] = entries;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== currentPage || $[9] !== handlePageChange || $[10] !== total || $[11] !== totalPages) {
    t5 = totalPages > 1 && <div className="mt-10 xl:mt-14"><PaginationNumber wrapperClassName="justify-center" currentPage={currentPage} totalPages={totalPages} totalItems={total} onPageChange={handlePageChange} /></div>;
    $[8] = currentPage;
    $[9] = handlePageChange;
    $[10] = total;
    $[11] = totalPages;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <Container className="relative my-10 xl:my-14" {...t3}>{t4}{t5}</Container>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t2 || $[17] !== t6) {
    t7 = <>{t2}{t6}</>;
    $[16] = t2;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
function _temp(news, index) {
  return <NewsCard key={news.documentId ?? `${news.url}-${index}`} news={news} index={index} />;
}